define('glu/grid/adoptRegion',['require','marionette','../util'],function(require) {
    'use strict';

    var Marionette = require('marionette'),
        util = require('../util');

    /**
     * Designed to inject the regions element reference into the view.  In this
     * manner there is no extra nesting within the region for the view.
     * This is necessary for a table layout that would forbid an immediate child of div
     * inside of a thead or tbody tag.
     */

    return Marionette.Region.extend({
        show: function(view, options) {
            this.ensureEl();
            var showOptions = options || {};
            var isViewClosed = view.isClosed || util.isUndefined(view.$el);
            var isDifferentView = view !== this.currentView;
            var preventClose = !!showOptions.preventClose;

            // only close the view if we don't want to preventClose and the view is different
            var shouldCloseView = !preventClose && isDifferentView;

            if (shouldCloseView) {
                this.close();
            }

            Marionette.triggerMethod.call(this, 'before:show', view);

            if (util.isFunction(view.triggerMethod)) {
                view.triggerMethod('before:show');
            } else {
                Marionette.triggerMethod.call(view, 'before:show');
            }

            if (isDifferentView || isViewClosed) {
                this.open(view);
            }

            view.render();

            this.currentView = view;

            Marionette.triggerMethod.call(this, 'show', view);

            if (util.isFunction(view.triggerMethod)) {
                view.triggerMethod('show');
            } else {
                Marionette.triggerMethod.call(view, 'show');
            }

            return this;
        },
        open: function(view) {
            this.$el.empty();
            view.setElement(this.$el);
        }
    });
});

